var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fedsm_91-0qXaO6Mb56K5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["login@loblaw-digital-pcid"]={id:"fedsm_91-0qXaO6Mb56K5"};
      